import React from 'react';
import PropTypes from 'prop-types';
import Lock from '@material-ui/icons/Lock';
import { Grid, TextField, InputAdornment } from '@material-ui/core';

export function PasswordImpl({ failedLogin }) {
  return (
    <Grid item xs={12}>
      <TextField
        required
        type="password"
        name="password"
        placeholder="*********"
        style={{
          width: '100%',
        }}
        label="Password"
        error={!!failedLogin}
        helperText={failedLogin ? 'The username or password you entered is incorrect' : ''}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
}

PasswordImpl.propTypes = {
  failedLogin: PropTypes.string.isRequired,
};

export default (PasswordImpl);
